// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BulkCTCUpload.css */

.bulk-ctc-wrapper {
  padding: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.bulk-ctc-step-container {
  margin-top: 20px;
}

/* Form & Input Controls */
.bulk-ctc-flex-row {
  display: flex;
  gap: 20px;
  align-items: flex-end;
  margin-bottom: 20px;
}

.bulk-ctc-input-group {
  flex: 1 1;
}

.bulk-ctc-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #374151;
}

.bulk-ctc-select {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  outline: none;
  font-family: inherit;
}

.bulk-ctc-select:focus {
  border-color: #2563eb;
}

/* Upload Zone */
.bulk-upload-zone {
  padding: 20px;
  border: 2px dashed #d1d5db;
  border-radius: 6px;
  background-color: #f9fafb;
}

.bulk-file-input {
  margin-bottom: 15px;
  display: block;
}

/* Buttons */
.btn-bulk-secondary {
  padding: 10px 20px;
  background-color: #4b5563;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.btn-bulk-secondary:hover:not(:disabled) {
  background-color: #374151;
}

.btn-bulk-primary {
  padding: 10px 20px;
  background-color: #2563eb;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.btn-bulk-primary:hover:not(:disabled) {
  background-color: #1d4ed8;
}

.btn-bulk-success {
  padding: 8px 16px;
  background-color: #10b981;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}

.btn-bulk-success:hover:not(:disabled) {
  background-color: #059669;
}

.btn-bulk-cancel {
  padding: 8px 16px;
  margin-right: 10px;
  background-color: #e5e7eb;
  color: #374151;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}

.btn-bulk-cancel:hover {
  background-color: #d1d5db;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Preview Section */
.preview-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.error-banner {
  padding: 12px;
  background-color: #fef2f2;
  color: #b91c1c;
  border: 1px solid #f87171;
  border-radius: 4px;
  margin-bottom: 15px;
}

/* Table Styles */
.bulk-table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

.bulk-preview-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.bulk-preview-table thead {
  background-color: #f3f4f6;
}

.bulk-preview-table th {
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

.bulk-preview-table td {
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
  color: #4b5563;
}

.ctc-highlight {
  font-weight: bold;
  color: #111827;
}

.no-data-text {
  padding: 20px;
  text-align: center;
  color: #6b7280;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/SalaryStructure/BulkCTCUpload.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["/* BulkCTCUpload.css */\n\n.bulk-ctc-wrapper {\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.bulk-ctc-step-container {\n  margin-top: 20px;\n}\n\n/* Form & Input Controls */\n.bulk-ctc-flex-row {\n  display: flex;\n  gap: 20px;\n  align-items: flex-end;\n  margin-bottom: 20px;\n}\n\n.bulk-ctc-input-group {\n  flex: 1;\n}\n\n.bulk-ctc-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.bulk-ctc-select {\n  width: 100%;\n  padding: 10px;\n  border-radius: 4px;\n  border: 1px solid #d1d5db;\n  outline: none;\n  font-family: inherit;\n}\n\n.bulk-ctc-select:focus {\n  border-color: #2563eb;\n}\n\n/* Upload Zone */\n.bulk-upload-zone {\n  padding: 20px;\n  border: 2px dashed #d1d5db;\n  border-radius: 6px;\n  background-color: #f9fafb;\n}\n\n.bulk-file-input {\n  margin-bottom: 15px;\n  display: block;\n}\n\n/* Buttons */\n.btn-bulk-secondary {\n  padding: 10px 20px;\n  background-color: #4b5563;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.btn-bulk-secondary:hover:not(:disabled) {\n  background-color: #374151;\n}\n\n.btn-bulk-primary {\n  padding: 10px 20px;\n  background-color: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.btn-bulk-primary:hover:not(:disabled) {\n  background-color: #1d4ed8;\n}\n\n.btn-bulk-success {\n  padding: 8px 16px;\n  background-color: #10b981;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.btn-bulk-success:hover:not(:disabled) {\n  background-color: #059669;\n}\n\n.btn-bulk-cancel {\n  padding: 8px 16px;\n  margin-right: 10px;\n  background-color: #e5e7eb;\n  color: #374151;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.btn-bulk-cancel:hover {\n  background-color: #d1d5db;\n}\n\nbutton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Preview Section */\n.preview-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.error-banner {\n  padding: 12px;\n  background-color: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #f87171;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n\n/* Table Styles */\n.bulk-table-wrapper {\n  overflow-x: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n}\n\n.bulk-preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n\n.bulk-preview-table thead {\n  background-color: #f3f4f6;\n}\n\n.bulk-preview-table th {\n  padding: 12px;\n  border-bottom: 1px solid #e5e7eb;\n  font-weight: 600;\n  color: #374151;\n  white-space: nowrap;\n}\n\n.bulk-preview-table td {\n  padding: 12px;\n  border-bottom: 1px solid #e5e7eb;\n  color: #4b5563;\n}\n\n.ctc-highlight {\n  font-weight: bold;\n  color: #111827;\n}\n\n.no-data-text {\n  padding: 20px;\n  text-align: center;\n  color: #6b7280;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
